"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.object.to-string");

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _constants = require("../constants");

var _CategoryNavbarMobile = _interopRequireDefault(require("../components/CategoryNavbarMobile"));

var _SearchBar = _interopRequireDefault(require("../components/SearchBar"));

require("./SubNavWrapperMobile.css");

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !_construct.default) return false;
    if (_construct.default.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call((0, _construct.default)(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = (0, _getPrototypeOf2.default)(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
      result = (0, _construct.default)(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2.default)(this, result);
  };
}

var SEARCH_BOX_COINTAINER_WIDTH = 210;

var SubNavWrapperMobile = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(SubNavWrapperMobile, _React$Component);

  var _super = _createSuper2(SubNavWrapperMobile);

  function SubNavWrapperMobile(props) {
    var _this;

    (0, _classCallCheck2.default)(this, SubNavWrapperMobile);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onCategoryHover", function (category, showFlyout) {
      _this.setState({
        showFlyout: showFlyout,
        activeCategory: category
      }, function () {});
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "enableFlyout", function (showFlyout) {
      _this.setState({
        showFlyout: showFlyout
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleSearchIconClick", function () {
      _this.catNavbarRef && _this.catNavbarRef.current && _this.catNavbarRef.current.hideNav(true);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleCloseIconClick", function () {
      _this.catNavbarRef && _this.catNavbarRef.current && _this.catNavbarRef.current.hideNav(false);
    });
    _this.state = {
      categories: null
    };
    _this.flyoutRef = _react.default.createRef();
    _this.catNavbarRef = _react.default.createRef();
    return _this;
  }

  (0, _createClass2.default)(SubNavWrapperMobile, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var categoryCache = this.props.categoryCache;
      categoryCache && categoryCache.listenToCatalog(function (categories) {
        _this2.setState({
          categories: categories
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var brandType = this.props.brandType;
      return _react.default.createElement("div", {
        className: "uig-sub-nav-mobile-wrapper brand-".concat(brandType)
      }, _react.default.createElement("div", {
        className: "uig-sub-nav-mobile-container"
      }, _react.default.createElement(_CategoryNavbarMobile.default, (0, _extends2.default)({
        ref: this.catNavbarRef,
        categories: this.state.categories
      }, this.props)), _react.default.createElement(_SearchBar.default, {
        formID: 'mobileNavSearchBar',
        brandType: brandType,
        isCloseButtonNeeded: true,
        handleCloseIconClick: this.handleCloseIconClick,
        handleSearchIconClick: this.handleSearchIconClick,
        jwtToken: this.props.jwtToken,
        user: this.props.user
      })));
    }
  }]);
  return SubNavWrapperMobile;
}(_react.default.Component);

exports.default = SubNavWrapperMobile;
SubNavWrapperMobile.propTypes = {
  categoryCache: _propTypes.default.object,
  selectedCategoryId: _propTypes.default.string,
  // todo use this
  brandType: _propTypes.default.string
};
SubNavWrapperMobile.defaultProps = {
  categoryCache: null,
  selectedCategoryId: '',
  brandType: _constants.BRANDS.SHUTTERFLY
};